import Paciente from '@/api/paciente'
import _ from 'lodash'
import Vue from 'vue'

const state = {
  paciente: null,
  filtrosSolapaGeneral: {},
  vuelveDeDetalle: false,
  cargando: true,
  editando: false
}

const getters = {
  cargando: state => {
    return state.cargando
  },
  paciente: state => {
    return state.paciente
  },
  personaSeleccionada: (state, getters, rootState) => {
    return rootState.persona.persona
  },
  editando: state => {
    return state.editando
  },
  visiblePorUsuario: (state, getters, rootState) => instituciones => {
    let visible = false
    if (rootState.auth.user) {
      /* instituciones.forEach(institucion => {
        if (
          _.findIndex(rootState.auth.user.instituciones_ids, o => {
            return parseInt(o) === institucion.institucion_id
          }) > -1
        ) {
          visible = true
        }
      }) */
      visible = true
    }
    return visible
  },
  filtrosSolapaGeneral: state => {
    return state.filtrosSolapaGeneral
  },
  vuelveDeDetalle: state => {
    return state.vuelveDeDetalle
  }
}

const actions = {
  obtener (context, payload) {
    const { id } = payload

    return new Promise((resolve, reject) => {
      Paciente.obtener(id).then(
        data => {
          if (context.getters.visiblePorUsuario(data.instituciones)) {
            context.commit('cargando', false)
            context.commit('setearPaciente', data)
            resolve(data)
          } else {
            // context.commit('mostrarError', 'No podes ver al paciente')
            reject(new Error('No podes ver al paciente'))
          }
        },
        error => {
          context.commit('cargando', false)
          reject(error)
        }
      )
    })
  },
  actualizarSeccion (context, payload) {
    const datos = payload

    datos.id = context.getters.paciente.id

    return new Promise((resolve, reject) => {
      Paciente.guardar(datos).then(
        data => {
          Vue.notify({
            group: 'general',
            type: 'success',
            text: 'Los datos se guardaron correctamente!'
          })
          context.commit('actualizar', data)
          resolve(data)
        },
        error => {
          // context.commit('loginUserFailure', error)
          reject(error)
          // }, 500)
        }
      )
    })
  },
  editar (context, payload) {
    context.commit('editar', payload)
  }
}

const mutations = {
  cargando (state, payload) {
    state.cargando = payload
  },
  setearPaciente (state, paciente) {
    state.paciente = paciente
  },
  setearPersona (state, persona) {
    state.paciente.persona = persona
  },

  actualizar (state, datos) {
    state.cargando = false
    state.paciente = _.assign(state.paciente, datos)
  },
  actualizarPersona (state, datos) {
    state.paciente.persona = _.assign(state.paciente.persona, datos)
  },
  editar (state, valor) {
    state.editando = valor
  },
  guardarFiltrosSolapaGeneral (state, datos) {
    state.filtrosSolapaGeneral = datos
  },
  vuelveDeDetalle (state, valor) {
    state.vuelveDeDetalle = valor
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
